import React from 'react';
import { FaYoutube, FaFacebookF, FaInstagram } from 'react-icons/fa'; 
import { FaXTwitter } from 'react-icons/fa6';
// react-icons for social brands
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import logo from '../../utils/static/logo2.png';

const Footer = () => {
  const { t } = useTranslation();
  return (
    <footer className="bg-white border-t border-gray-200 mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          
          {/* Brand Column */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <img src={logo} to="/"  alt="Brand logo" className="h-7 w-auto" />
            </div>
            <p className="text-black text-sm leading-relaxed">
              {t('footer.description')}
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-sm font-semibold text-black tracking-wider uppercase mb-4">{t('footer.platform')}</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/map" className="text-base text-black hover:text-gray-900 transition-colors">
                  {t('footer.map')}
                </Link>
              </li>
              <li>
                <Link to="/events" className="text-base text-black hover:text-gray-900 transition-colors">
                  {t('footer.community')}
                </Link>
              </li>
              <li>
                <Link to="/admin/providers" className="text-base text-black hover:text-gray-900 transition-colors">
                  {t('footer.provider')}
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal / Contact */}
          <div>
            <h3 className="text-sm font-semibold text-black tracking-wider uppercase mb-4">{t('footer.contact')}</h3>
            <ul className="space-y-3">
              <li>
               <a 
                  href="mailto:hello@somosmas.ch" 
                  className="text-base text-black hover:text-gray-900"
                >
                  {t('footer.help')}
                </a>
              </li>
              <li>
                <Link to="/privacy" className="text-base text-black hover:text-gray-900">
                  {t('footer.privacy')}
                </Link>
              </li>
              <li>
                <Link to="/terms-of-service" className="text-base text-black hover:text-gray-900">
                  {t('footer.terms-of-service')}
                </Link>
              </li>
            </ul>
          </div>
        </div>
        
        <div className="mt-8 border-t border-gray-100 pt-8 flex justify-between items-center">
          <p className="text-sm text-black">
            &copy; {new Date().getFullYear()} {t('footer.rights')}
          </p>
          <div className="flex gap-1">
            {/* Social Icons Placeholder */}

            <a href="https://www.youtube.com/@FPROCLADE" target="_blank" rel="noopener noreferrer"
              className="p-2 rounded-full bg-white/5 hover:bg-white/10 transition" aria-label="Youtube">
              <FaYoutube color="#FF0000" className="h-4 w-4" />
            </a>

            <a href="https://www.facebook.com/PROCLADE" target="_blank" rel="noopener noreferrer"
              className="p-2 rounded-full bg-white/5 hover:bg-white/10 transition" aria-label="Facebook">
              <FaFacebookF color="#1877F2" className="h-4 w-4" />
            </a>

            <a href="https://twitter.com/fproclade" target="_blank" rel="noopener noreferrer"
              className="p-2 rounded-full bg-white/5 hover:bg-white/10 transition" aria-label="Twitter">
              <FaXTwitter className="h-4 w-4" />
            </a>

            <a href="https://www.instagram.com/fundacion_proclade/?hl=es" target="_blank" rel="noopener noreferrer"
              className="p-2 rounded-full bg-white/5 hover:bg-white/10 transition" aria-label="Instagram">
              <FaInstagram color="#E1306C" className="h-4 w-4" />
            </a>
                
           </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
